/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Tag_ScanInputs */

const en_for_whom_tag_scan = /** @type {(inputs: For_Whom_Tag_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calories from a photo`)
};

const pl_for_whom_tag_scan = /** @type {(inputs: For_Whom_Tag_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalorie ze zdjęcia`)
};

/**
* | output |
* | --- |
* | "Calories from a photo" |
*
* @param {For_Whom_Tag_ScanInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_tag_scan = /** @type {((inputs?: For_Whom_Tag_ScanInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Tag_ScanInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_tag_scan(inputs)
	return en_for_whom_tag_scan(inputs)
});